/* Amlove · Family rug intro (sections/am-rug-family-intro.liquid).
   Timeline: rug alone → rug rises → Mom options → choose → Dad options → choose → Child options → choose
   → whole family, rug back to center → repeat. Each choice changes only that person on the rug.
   Pauses while off screen or in a hidden tab; respects "reduce motion"; works with the theme editor. */
(function () {
  'use strict';
  var ROLES = ['mom', 'dad', 'kid'];

  function num(el, name, def) { var v = parseFloat(el.getAttribute(name)); return isNaN(v) ? def : v; }

  function init(root) {
    if (!root || root.__amrf) return;
    root.__amrf = true;
    root.classList.add('is-boot');

    var cfg = {
      autoplay: root.getAttribute('data-autoplay') !== 'false',
      loop: root.getAttribute('data-loop') !== 'false',
      intro: num(root, 'data-intro', 3500),
      step: num(root, 'data-step', 550),
      hold: num(root, 'data-hold', 1800),
      fin: num(root, 'data-final', 4500),
      move: num(root, 'data-move', 1100),
      pop: root.getAttribute('data-pop') !== 'false'
    };
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var still = mq.matches;
    var pauseBtn = root.querySelector('[data-amrf-pause]');
    var label = root.querySelector('[data-amrf-label]');
    var fitEl = root.querySelector('[data-amrf-fit]');
    var family = root.querySelector('[data-amrf-family]');
    var groups = {}, figs = {}, cur = {};
    ROLES.forEach(function (r) {
      groups[r] = root.querySelector('[data-opts="' + r + '"]');
      figs[r] = Array.prototype.slice.call(root.querySelectorAll('[data-member="' + r + '"] .amrf__fig'));
      cur[r] = 0;
    });
    var state = { gen: 0, paused: still || !cfg.autoplay, offscreen: false, editor: false, cycle: 0 };

    /* ---------- text fitting: keep the rug text inside the print area ---------- */
    function fit() {
      if (!fitEl) return;
      fitEl.style.setProperty('--fit', '1');
      var box = fitEl.parentNode;
      var limitBottom = family ? family.getBoundingClientRect().top : Infinity;
      var gap = 0;
      if (family) {
        var cs = getComputedStyle(root);
        var g = parseFloat(cs.getPropertyValue('--amrf-text-gap')) || 0;
        gap = family.getBoundingClientRect().width * g / 100;
      }
      var f = 1;
      for (var i = 0; i < 14; i++) {
        var tooWide = fitEl.scrollWidth > fitEl.clientWidth + 1;
        var lh = parseFloat(getComputedStyle(fitEl).fontSize) * 1.05;
        var lines = Math.round(fitEl.getBoundingClientRect().height / lh);
        var tooLow = box.getBoundingClientRect().bottom > limitBottom - gap;
        if (!tooWide && lines <= 2 && !tooLow) break;
        f -= .05;
        if (f < .45) break;
        fitEl.style.setProperty('--fit', String(f));
      }
    }
    var fitRaf = 0;
    function queueFit() { cancelAnimationFrame(fitRaf); fitRaf = requestAnimationFrame(fit); }

    /* ---------- view helpers ---------- */
    function scene(s, role) {
      root.setAttribute('data-scene', s);
      if (role) { root.setAttribute('data-role', role); root.setAttribute('data-focus', role); }
      else { root.removeAttribute('data-focus'); }
    }
    function tabs(role, done) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-r]'), function (x) {
        var r = x.getAttribute('data-r');
        x.classList.toggle('is-active', r === role);
        x.classList.toggle('is-done', done.indexOf(r) > -1 && r !== role);
      });
    }
    function showGroup(role) {
      ROLES.forEach(function (r) {
        if (!groups[r]) return;
        groups[r].classList.toggle('is-in', r === role);
        if (r !== role) Array.prototype.forEach.call(groups[r].children, function (c) { c.classList.remove('is-hover', 'is-sel'); });
      });
      if (role === null && label) label.classList.add('is-out');
    }
    function opts(role) { return groups[role] ? Array.prototype.slice.call(groups[role].children) : []; }
    var labelTimer = 0;
    function setLabel(text) {
      if (!label) return;
      label.classList.add('is-out');
      clearTimeout(labelTimer);
      labelTimer = setTimeout(function () { label.textContent = text || ''; label.classList.remove('is-out'); }, still ? 0 : 150);
    }
    function hover(role, i) {
      opts(role).forEach(function (c, k) { c.classList.toggle('is-hover', k === i); });
      var c = opts(role)[i];
      setLabel(c ? c.getAttribute('data-label') : '');
    }
    function select(role, i) { opts(role).forEach(function (c, k) { c.classList.remove('is-hover'); c.classList.toggle('is-sel', k === i); }); }
    function setFig(role, i, pop) {
      cur[role] = i;
      figs[role].forEach(function (f, k) {
        var on = k === i;
        f.classList.toggle('is-on', on);
        f.classList.remove('is-pop');
        if (on) {
          if (f.loading === 'lazy') f.loading = 'eager';
          if (pop && cfg.pop && !still) { void f.offsetWidth; f.classList.add('is-pop'); }
        }
      });
    }

    /* ---------- pausable timeline ---------- */
    function held() { return state.paused || state.offscreen || state.editor || document.hidden; }
    function sleep(ms, gen) {
      return new Promise(function (res) {
        var left = ms, last = performance.now();
        function tick(now) {
          if (gen !== state.gen) return res(false);
          if (!held()) left -= now - last;
          last = now;
          if (left <= 0) return res(true);
          requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }
    function run(from) {
      var gen = ++state.gen;
      var step = from || 0;
      (function loop() {
        var done = [];
        var p = Promise.resolve(true);
        function then(fn) { p = p.then(function (ok) { return ok ? fn() : false; }); }
        if (step === 0) {
          then(function () { showGroup(null); scene('intro'); tabs(null, []); return sleep(cfg.intro, gen); });
        }
        then(function () { scene('pick', ROLES[Math.max(0, step - 1)]); return sleep(step === 0 ? cfg.move : 300, gen); });
        ROLES.forEach(function (role, k) {
          if (step > k + 1) { done.push(role); return; }
          var list = opts(role);
          if (!list.length || figs[role].length < 2) { done.push(role); return; }
          var t, path;
          then(function () { showGroup(null); return sleep(k === 0 && step <= 1 ? 0 : 340, gen); });
          then(function () {
            scene('pick', role); tabs(role, done);
            showGroup(role);
            var n = Math.min(list.length, figs[role].length);
            t = (cur[role] + 1 + ((state.cycle + k) % Math.max(1, n - 1))) % n;
            path = [];
            for (var x = 0; x < n && path.length < 2; x++) if (x !== t) path.push(x);
            return sleep(900, gen);
          });
          then(function () { hover(role, path[0]); return sleep(cfg.step, gen); });
          then(function () { if (path[1] !== undefined) hover(role, path[1]); return sleep(path[1] !== undefined ? cfg.step : 0, gen); });
          then(function () { hover(role, t); return sleep(cfg.step + 60, gen); });
          then(function () { select(role, t); return sleep(400, gen); });
          then(function () { setFig(role, t, true); done.push(role); tabs(role, done); return sleep(cfg.hold, gen); });
        });
        then(function () { showGroup(null); return sleep(300, gen); });
        then(function () { scene('done'); tabs(null, ROLES); return sleep(cfg.fin, gen); });
        p.then(function (ok) {
          if (!ok || gen !== state.gen) return;
          state.cycle++;
          step = 0;
          if (cfg.loop) loop();
        });
      })();
    }

    /* ---------- controls and environment ---------- */
    function setPaused(v) {
      state.paused = v;
      if (pauseBtn) {
        pauseBtn.setAttribute('aria-pressed', v ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', v ? pauseBtn.getAttribute('data-label-play') : pauseBtn.getAttribute('data-label-pause'));
      }
    }
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!state.paused); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { state.offscreen = !es[0].isIntersecting; }, { threshold: .15 });
      io.observe(root);
    }
    var onMq = function (e) { still = e.matches; if (still) setPaused(true); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    if ('ResizeObserver' in window && fitEl) new ResizeObserver(queueFit).observe(fitEl.parentNode.parentNode);
    else window.addEventListener('resize', queueFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueFit);

    setPaused(state.paused);
    queueFit();
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('is-boot'); }); });
    run(0);

    /* theme editor: selecting a Character block shows that option chosen on the rug */
    root.__amrfShow = function (opt) {
      var g = opt.parentNode, role = g.getAttribute('data-opts');
      var i = Array.prototype.indexOf.call(g.children, opt);
      state.gen++;
      state.editor = true;
      scene('pick', role); tabs(role, []); showGroup(role); hover(role, i); select(role, i); setFig(role, i, false);
    };
    root.__amrfRelease = function () { if (!state.editor) return; state.editor = false; run(0); };
    root.__amrfStop = function () { state.gen++; };
    root.__amrfFit = queueFit;
  }

  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('[data-amrf]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-amrf]');
    if (r && r.__amrfStop) r.__amrfStop();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var opt = e.target && e.target.closest && e.target.closest('.amrf__opt');
    var r = opt && opt.closest('[data-amrf]');
    if (r && r.__amrfShow) r.__amrfShow(opt);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var r = e.target && e.target.closest && e.target.closest('[data-amrf]');
    if (r && r.__amrfRelease) r.__amrfRelease();
  });
})();
